export default {
    values: {
        'NPS Survey': 'NPS Survey',
        'NPS Answers': 'NPS Answers',
        'Responses collected from the popup': 'Responses collected from the popup',
        'Could not load NPS answers': 'Could not load NPS answers',
        'Could not load platform users': 'Could not load platform users',
        'Are you sure you want to delete?': 'Are you sure you want to delete?',
        'NPS answer deleted successfully': 'NPS answer deleted successfully',
        'Error deleting NPS answer': 'Error deleting NPS answer',
        'Please select a user': 'Please select a user',
        'This user is already registered': 'This user is already registered',
        'User registered successfully': 'User registered successfully',
        'Could not register user': 'Could not register user',
        'Add User': 'Add User',
        'Add User to NPS survey': 'Add User to NPS survey',
        'User': 'User',
        'Select user': 'Select user',
        'All available users are already registered': 'All available users are already registered',
        'Score': 'Score',
        'Comment': 'Comment',
        'Answered': 'Answered',
        'Answered At': 'Answered At',
        'Retries': 'Retries',
        'Last Retry': 'Last Retry',
        'Actions': 'Actions',
        'No NPS answers yet': 'No NPS answers yet',
        'Responses submitted in the popup will appear here.': 'Responses submitted in the popup will appear here.',
        'Yes': 'Yes',
        'No': 'No',
        'Delete': 'Delete',
        'Thanks for answering the NPS survey': 'Thanks for answering the NPS survey',
        'Could not submit your NPS answer': 'Could not submit your NPS answer',
        'Could not update retry information': 'Could not update retry information',
        'Close': 'Close',
        'How likely are you to recommend this platform to a colleague?': 'How likely are you to recommend this platform to a colleague?',
        'Choose a score from 0 to 10': 'Choose a score from 0 to 10',
        'Not likely': 'Not likely',
        'Very likely': 'Very likely',
        'Comment (optional)': 'Comment (optional)',
        'Tell us what influenced your score': 'Tell us what influenced your score',
        'Submitting...': 'Submitting...',
        'Send feedback': 'Send feedback'
    }
}
